import React from 'react';
import '../App.css';
import {goBack} from './../action/redirection'
import { connect } from 'react-redux'
import { withRouter } from 'react-router';

class CustError extends React.Component {
    constructor(props){
        super(props);

    }

    previousPage=(e)=>{
        e.preventDefault();
        //this.props.history.go(-1);    
        goBack(this.props.dispatch)                          
       
    }

    render(){
        return(
    <React.Fragment>
<main className="main bg-white padding-horiz-zero margin-bottom-xlarge">
    <div className="show-for-medium-up large-container" style={{backgroundImage:
    "url(https://www.verizon.com/home/accessories/media/images-accessories/VZ_123860_17_TVLRfriends_GR13_V2.png)", backgroundRepeat: "no-repeat",
    backgroundSize: "cover", minHeight: "550px", backgroundPosition: "35% center"}} title="Photo of children on a
    sofa">
        <div className="padding-top-large medium-padding-top-xlarge">
            <div className="cmb-container">
                <div className="row">
                    <div className="columns tiny-12 medium-5 apex_bold"
                        style={{padding: "1.2rem 1.5rem ", width:
                    "390px ", maxWidth: "100%", float: "left", marginLeft: "40px", backgroundColor: "rgba(255, 255, 255, 0.75)"}}>
                        <h5 className="tiny-header-h4 medium-header-h3 margin-top-zero medium-margin-bottom-xlarge p-85
                        medium-p-85 large-p-95"> Uh-oh. Much like that TV remote lost somewhere in the sofa cushions,
                            this page has gone missing.</h5>
                        <p className="f16 apex_book p-85 medium-p-85 large-p-95">Use the navigation in the page header
                            above
                            to find your way, or <a onClick={this.previousPage}>go back to the previous page.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="hide-for-medium-up large-container" style={{backgroundImage:
    "url(https://www.verizon.com/home/accessories/media/images-accessories/VZ_123860_17_TVLRfriends_GR13_V2_resmob.png)", backgroundRepeat:
    "no-repeat", backgroundSize: "cover", minHeight: "550px", backgroundPosition: "35% center"}} title="Photo of children
    on a sofa">
        <div className="padding-top-large medium-padding-top-xlarge">
            <div className="cmb-container">
                <div className="row">
                    <div className="columns tiny-12 medium-5 apex_bold"
                        style={{padding: "1.2rem 1.5rem ", width:
                    "300px ", maxWidth: "100%", float: "left", marginLeft: "20px", backgroundColor: "rgba(255, 255, 255, 0.75)"}}>
                        <h5 className="tiny-header-h4 medium-header-h3 margin-top-zero medium-margin-bottom-xlarge p-85
                        medium-p-85 large-p-95"> Uh-oh. Much like that TV remote lost somewhere in the sofa cushions,
                            this page has gone missing.</h5>
                        <p className="f16 apex_book p-85 medium-p-85 large-p-95">Use the navigation in the page header
                            above
                            to find your way, or <a onClick={this.previousPage}>go back to the previous page.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </main>
</React.Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        appState: state.appVTP,
        categoriesState: state.categoriesVTP,
        errorState: state.errorVTP
    }
}
export default withRouter(connect(mapStateToProps)(CustError));
